import React from "react";
import { css, cx } from "emotion";
import { contentStyle } from "./style";

export const PanelContent = ({ className, children }) => {
	return (
		<div
			className={cx(
				css`
					${contentStyle}
				`,
				className
			)}
		>
			{children}
		</div>
	);
};

export default PanelContent;
